import dayjs from "dayjs";
const converterTimeZone = (utcTime, localTimeZone, requiredTimeZone) => {
  if (localTimeZone === requiredTimeZone) {
    return utcTime;
  } else {
    const toRequiredTimeZone = dayjs
      .utc(utcTime, "YYYYMMDD HH:mm")
      .clone()
      .tz(requiredTimeZone)
      .format("YYYY-MM-DD HH:mm");
    const toLocalTimeZone = dayjs
      .tz(toRequiredTimeZone, localTimeZone)
      .utc()
      .format();
    return toLocalTimeZone;
  }
};

export default converterTimeZone;
